<template>
  <div class="content">
    <div ref="tabList" class="tab-list">
      <div class="tab" :style="`height: ${boxHeight}px`">
        <div class="title-container">
          <p class="title bold">公告</p>
          <div class="arrow-container">
            <p @click="leftArrowClick" :class="{leftArrow: true,on: latestNoticesIndex > 0}"></p>
            <p @click="rightArrowClick" :class="{rightArrow: true,on: latestNoticesIndex < cardList.latestNotices.list.length - 1}"></p>
          </div>
        </div>
        <div class="wordContent">
          <ul :style="`transform: translateX(-${latestNoticesIndex * 100}%)`">
            <li @click="goAnnouce(item)" :title="item.title" class="overflow2" v-for="(item,index) in cardList.latestNotices.list" :key="index">{{item.title}}</li>
          </ul>
        </div>
      </div>
      <div ref="tings" class="tab todos" :style="`height: ${boxHeight}px`">
        <div class="title-container">
          <p class="title bold">待处理</p>
          <div class="arrow-container">
            <p @click="dealLeft" :class="{leftArrow: true,on: dealIndex > 0}"></p>
            <p @click="dealRight" :class="{rightArrow: true,on: dealIndex < dealList.length - 3}"></p>
          </div>
        </div>
        <div ref="tingsContent" class="tingsContent">
          <ul :style="`transform: translateX(-${dealIndex * thingWidth * 3}px)`">
            <li @click="goDynamicRoute(item)" v-for="(item, index) in todos" :key="index" :class="{on: index === Number(dealIndex) * 3 + 2}"
              :style="`min-width: ${thingWidth}px;min-height: ${thingHeight}px;`">
              <p :class="{num: true, grey: item.count == 0}">{{item.count}}</p>
              <p>{{item.title}}</p>
            </li>
          </ul>
        </div>
      </div>
      <div v-show="cardList.bsEdit.is_show" class="tab common" :style="`height: ${boxHeight}px`">
        <div class="useTab">
          <div class="left-container">
            <span>视频剪辑</span>
            <p>实时在线剪辑原创视频</p>
          </div>
          <div class="right-container">
            <p class="videoEdit"></p>
          </div>
        </div>
      </div>
      <div v-show="cardList.meiZi.is_show" @click="navigateToMZ" class="tab common" :style="`height: ${boxHeight}px`">
        <div class="useTab">
          <div class="left-container">
            <span>回调媒资</span>
            <p>媒资库检索更专业的素材</p>
          </div>
          <div class="right-container">
            <p class="mzCallback"></p>
          </div>
        </div>
      </div>
      <div v-show="cardList.live.is_show" class="tab common" :style="`height: ${boxHeight}px`">
        <div class="useTab">
          <div class="left-container">
            <span>在线直播</span>
            <p>自编播单体验在线云导播</p>
          </div>
          <div class="right-container">
            <p class="cloudLive"></p>
          </div>
        </div>
      </div>
      <div v-show="cardList.dataCenter.is_show" @click="navigate(cardList.dataCenter.menu_type,cardList.dataCenter.idstring)" class="tab common" :style="`height: ${boxHeight}px`">
        <div class="useTab">
          <div class="left-container">
            <span>数据中心</span>
            <p>全面掌握报道数据</p>
          </div>
          <div class="right-container">
            <p class="dataCenter"></p>
          </div>
        </div>
      </div>
      <div v-show="cardList.appraisal.is_show" @click="navigate(cardList.appraisal.menu_type,cardList.appraisal.idstring)" class="tab common" :style="`height: ${boxHeight}px`">
        <div class="useTab">
          <div class="left-container">
            <span>考评打分</span>
            <p>多端稿件使用情况在线打分</p>
          </div>
          <div class="right-container">
            <p class="rank"></p>
          </div>
        </div>
      </div>
      <div v-show="cardList.proposal.is_show" @click="navigate(cardList.proposal.menu_type,cardList.proposal.idstring)" class="tab common" :style="`height: ${boxHeight}px`">
        <div class="useTab">
          <div class="left-container">
            <span>办公提案</span>
            <p>在线提交每周提案</p>
          </div>
          <div class="right-container">
            <p class="proposal"></p>
          </div>
        </div>
      </div>
      <!-- <div class="fillBox" :style="`width: ${boxWidth}px`"></div> -->
      <div class="fillBox" v-for="(item,index) in fillList" :key="index"></div>
    </div>
    <div class="content-container">
      <div class="search-cotnainer">
        <div class="left-container">
          <ul>
            <li v-for="(item,index) in tabList" :key="index" @click="pageType = item.key" :class="{on: item.key === pageType,bold:true}">{{item.title}}</li>
          </ul>
        </div>
        <div class="right-container list">
          <globalFilter ref="globalFilter" v-show="showFilter" />
        </div>
      </div>
      <!-- 如果没有权限显示 -->
      <div v-if="!loading">
        <noMore v-if="!show_list"></noMore>
        <empty v-else-if="empty" :msg="`暂无${empty}`" />
        <materialList v-else-if="pageType=='file'" class="materialList" :mList="mList"></materialList>
        <clueList v-else class="clueList" :clueList='clueList'></clueList>
      </div>
      <pages v-if="page.pageIndex>1||!loading" :page_count="page.pageCount" :index="page.pageIndex" :total="page.total"></pages>
    </div>
  </div>
</template>

<script>
// 传入的
import common from "@common/common";
import { apis } from "@common/config";
import resourceHandles from "@components/resourceHandles";
import empty from "@components/empty";
import pushBox from "@components/pushBox";
import checkers from "@components/checkers";
import globalFilter from "@components/globalFilter";
import materialList from "@components/materialList";
import clueList from "@components/clueList/clueList";
import noMore from "@components/noMore";
import pages from "@components/pages";

export default {
  name: "index",
  components: {
    resourceHandles,
    empty,
    pushBox,
    checkers,
    globalFilter,
    materialList,
    noMore,
    pages,
    clueList
  },
  data() {
    return {
      boxWidth: 0,
      boxHeight: 0,
      thingWidth: 0,
      thingHeight: 0,
      showFilter: true,
      page: {
        pageCount: 0,
        pageSize: 20,
        pageIndex: 1,
        total: 0
      },
      searchOptions: {},
      pageType: "file",
      tabList: [],
      mList: [],
      clueList: [],
      fillList: [],
      dealIndex: 0,
      dealList: ["采访", "采访", "采访", "采访"],
      cardList: {
        latestNotices: {
          list: []
        },
        appraisal: {
          is_show: false
        },
        bsEdit: {
          is_show: false
        },
        dataCenter: {
          is_show: false
        },
        live: {
          is_show: false
        },
        meiZi: {
          is_show: false
        },
        proposal: {
          is_show: false
        }
      },
      cardNum: 2,
      todos: [
        {
          type: 1,
          title: "采访",
          count: 0,
          able: false,
          name: "myInterviews",
          path: "/myInterviews",
          params: {
            status: 2
          }
        },
        {
          type: 2,
          title: "线索",
          count: 0,
          able: false,
          name: "myClue",
          path: "/myClue",
          params: {
            status: 0
          }
        },
        {
          type: 3,
          title: "报道",
          count: 0,
          able: false,
          name: "myreport",
          path: "/myreport"
        },
        {
          type: 4,
          title: "采访审核",
          count: 0,
          able: false,
          name: "checkInterviews",
          path: "/checkInterviews"
        },
        {
          type: 5,
          title: "资源分配",
          count: 0,
          able: false,
          name: "resources",
          path: "/resources"
        },
        {
          type: 6,
          title: "报道审核",
          count: 0,
          able: false,
          name: "examineReport",
          path: "/examineReport"
        },
        {
          type: 7,
          title: "发布",
          count: 0,
          able: false,
          name: "myPublish",
          path: "/myPublish"
        },
        {
          type: 8,
          title: "发布审核",
          count: 0,
          able: false,
          name: "publishAudit",
          path: "/publishAudit"
        }
      ],
      latestNoticesIndex: 0,
      show_list: true, //是否有权限全站检索,
      loading: true
    };
  },
  watch: {
    pageType(to) {
      this.$set(this.page, "pageSize", to == "file" ? 20 : 10);
      this.$set(this.page, "pageIndex", 1);
      this.pageType = to;
      this.getList();
    }
  },
  computed: {
    empty() {
      let { pageType, mList, clueList } = this;
      let empty = "";
      if (pageType == "file") {
        if (!mList || !mList.length) {
          empty = "素材";
        }
      } else {
        if (!clueList || !clueList.length) {
          empty = "线索";
        }
      }
      return empty;
    }
  },
  methods: {
    goAnnouce(i) {
      // 跳转公告详情
      this.$router.push({
        path: "/announcement",
        query: {
          d: i.id
        }
      });
    },
    leftArrowClick() {
      if (this.latestNoticesIndex > 0) {
        this.latestNoticesIndex--;
      }
    },
    rightArrowClick() {
      if (
        this.latestNoticesIndex <
        this.cardList.latestNotices.list.length - 1
      ) {
        this.latestNoticesIndex++;
      }
    },
    dealLeft() {
      if (this.dealIndex > 0) {
        this.dealIndex--;
      }
    },
    dealRight() {
      if (this.dealIndex < this.dealList.length - 3) {
        this.dealIndex++;
      }
    },
    goDynamicRoute(i) {
      // 跳转动态路由页面
      if (i.hasOwnProperty("able") && !i.able) return;

      if (i.count != 0) {
        this.$router.push({
          path: `/${i.menu_type}/${i.idstring}`
        });
      }
    },
    matchTodos(todos) {
      // 匹配待处理数据
      this.todos.forEach(i => {
        switch (i.type) {
          case 1:
            i.count = todos.interview.num;
            i.able = todos.interview.is_show - 0 === 1;
            i.search = todos.interview.has_search - 0 === 1;
            i.idstring = todos.interview.idstring;
            i.menu_type = todos.interview.menu_type;
            break;

          case 2:
            i.count = todos.material.num;
            i.able = todos.material.is_show - 0 === 1;
            i.search = todos.material.has_search - 0 === 1;
            i.idstring = todos.material.idstring;
            i.menu_type = todos.material.menu_type;
            break;

          case 3:
            i.count = todos.report.num;
            i.able = todos.report.is_show - 0 === 1;
            i.search = todos.report.has_search - 0 === 1;
            i.idstring = todos.report.idstring;
            i.menu_type = todos.report.menu_type;
            break;

          case 4:
            i.count = todos.interviewAudit.num;
            i.able = todos.interviewAudit.is_show - 0 === 1;
            i.search = todos.interviewAudit.has_search - 0 === 1;
            i.idstring = todos.interviewAudit.idstring;
            i.menu_type = todos.interviewAudit.menu_type;
            break;

          case 5:
            i.count = todos.resourceAllocation.num;
            i.able = todos.resourceAllocation.is_show - 0 === 1;
            i.search = todos.resourceAllocation.has_search - 0 === 1;
            i.idstring = todos.resourceAllocation.idstring;
            i.menu_type = todos.resourceAllocation.menu_type;
            break;

          case 6:
            i.count = todos.reportDistribution.num;
            i.able = todos.reportDistribution.is_show - 0 === 1;
            i.search = todos.reportDistribution.has_search - 0 === 1;
            i.idstring = todos.reportDistribution.idstring;
            i.menu_type = todos.reportDistribution.menu_type;
            break;

          // 待添加7、8，发布的字段
          case 7:
            i.count = todos.publish.num;
            i.able = todos.publish.is_show - 0 === 1;
            i.search = todos.publish.has_search - 0 === 1;
            i.idstring = todos.publish.idstring;
            i.menu_type = todos.publish.menu_type;
            break;

          case 8:
            i.count = todos.publishVerify.num;
            i.able = todos.publishVerify.is_show - 0 === 1;
            i.search = todos.publishVerify.has_search - 0 === 1;
            i.idstring = todos.publishVerify.idstring;
            i.menu_type = todos.publishVerify.menu_type;
            break;

          default:
            i.count = 0;
        }
      });
    },
    navigate(menu_type, idstring) {
      common.jump("/" + menu_type + "/" + idstring, true);
    },
    getCard() {
      const info = {};

      // 获取首页数据
      common.myFetch(apis.Index_card, info).then(data => {
        if (data) {
          let index = 0;
          for (const key in data) {
            if (data[key].is_show) {
              index++;
            }
          }
          // console.log(index)
          this.cardNum = index + 2;
          this.cardList = data;
          this.matchTodos(data.pendings);
          this.$nextTick(() => {
            this.calculateWidth();
          });
        }
      });
    },
    getList() {
      let data = {
        page: this.page.pageIndex,
        pagesize: this.page.pageSize,
        page_type: this.pageType,
        key_words: "",
        search_option: ""
      };
      this.loading = true;
      Object.assign(data, this.searchOptions);
      common.myFetch(apis.Index_search, data).then(res => {
        this.loading = false;
        if (res) {
          this.tabList = res.params.tab.option.list;
          this.pageType == "file"
            ? (this.mList = res.list)
            : (this.clueList = res.list);
          this.show_list = res.show_list;
          this.$set(
            this.page,
            "pageCount",
            common.calculatePage(res.page.row_count - 0, this.page.pageSize)
          );
          this.$set(this.page, "total", res.page.row_count - 0);
          this.generateSearchs(res.params.top_search.option.list);
        }
      });
    },
    generateSearchs(data) {
      // 整理搜索栏数据
      const types = data.map(i => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        };
      });

      const filterData = {
        types: types,
        callback: o => {
          this.getSearch(o);
        }
      };
      this.postSearch(filterData);
    },
    getSearch(d) {
      // 接收搜索框数据
      this.searchOptions = d;
      this.page.pageIndex = 1;
      this.getList();
    },
    postSearch(data) {
      // 发送搜索框数据
      this.$refs.globalFilter.getData(data);
      // this.$emit('filterData', data)
    },
    navigateToMZ() {
      let info = {};
      common.myFetch(apis.Usr_getlogintoken, info).then(r => {
        console.log(r);
        if (r) {
          common.jumpOut(r.host + "middle.html#/" + r.login_token);
          // this.$toast("修改成功");
        }
      });
    },
    calculateWidth() {
      const list = this.$refs.tabList;
      if (!list || !list.getBoundingClientRect()) return;
      const listWidth = list.getBoundingClientRect().width;
      let fillWidth = 0;
      const itemWidth = 251; // item dom宽度
      const itemGap = 20; //item 边距
      const listGap = 0; // list左右边距
      const countsPerPage = this.cardNum || 20; //每页的item数量
      const containerWidth = listWidth - listGap; //容器实际宽度（dom宽度 - 左右padding）
      const countsPerRow = parseInt(containerWidth / (itemWidth + itemGap)); //每行item数量
      const countsLastLine = countsPerPage % countsPerRow || countsPerRow; //最后一行的item数量
      const itemRatio = 108 / 251;
      const itemWidthNow = (listWidth - listGap) / countsPerRow - itemGap;
      const itemHeightNow = itemWidthNow * itemRatio;
      let arr = [];

      for (let index = 0; index < countsPerRow - countsLastLine; index++) {
        arr.push(index);
      }

      this.fillList = arr;

      fillWidth =
        countsPerRow === countsLastLine
          ? 0
          : (countsPerRow - countsLastLine) * (itemWidthNow + itemGap);

      this.boxWidth = fillWidth;
      this.boxHeight = itemHeightNow;
      this.$nextTick(() => {
        this.calThings();
      });
    },
    calThings() {
      const ting = this.$refs.tingsContent;
      if (!ting || !ting.getBoundingClientRect()) return;
      this.thingWidth = (ting.getBoundingClientRect().width) / 3;
      this.thingHeight = (this.thingWidth * 54) / 63;
    },
    addCalcEvent() {
      window.addEventListener("resize", () => {
        this.calculateWidth();
      });
    }
  },
  mounted() {
    this.calculateWidth();
    this.getCard();
    this.addCalcEvent();
    this.getList();
  }
};
</script>
<style src="@assets/css/index1.less" lang="less" scoped>
</style>
